<template>
    <div>
        <div
            class="fixed z-501 inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"
            id="my-modal"
        />
        <div class="absolute z-501 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 m-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div
                class="absolute top-4 right-4 cursor-pointer z-50"
                @click="$emit('close')"
            >
                <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
            </div>
            <div class="text-center">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Invite neighbor farmer</h3>
                <div class="px-7 py-3">
                    <p class="text-sm text-gray-500">
                        Invite your neighbor to update the field you have selected.
                    </p>
                </div>

                <div>
                    <div class="mb-4">
                        <div class="border-b border-gray-200">
                            <nav class="-mb-px flex justify-center" aria-label="Tabs">
                                <span
                                    v-for="tab in tabs"
                                    :key="tab.name"
                                    :class="[tab.name === activeTab
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm']"
                                    :aria-current="tab.name === activeTab ? 'page' : undefined"
                                    class="cursor-pointer"
                                    @click="changeTab(tab.name)"
                                >
                                    {{ tab.name }}
                                </span>
                            </nav>
                        </div>
                    </div>
                </div>

                <div class="text-left">
                    <div class="flex flex-wrap -mx-3">
                        <div
                            v-if="activeTab === 'Email'"
                            class="w-full px-3 mb-6"
                        >
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop">
                                Neighbor email
                            </label>
                            <div class="relative">
                                <input
                                    v-model="neighbourEmail"
                                    :class="{'border-red-500': errorMessages.email}"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 pr-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="email"
                                    type="email"
                                >
                            </div>
                            <p v-if="errorMessages.email" class="mt-2 text-red-500 text-xs italic">Please enter email address!</p>
                        </div>
                        <div
                            v-else
                            class="w-full px-3 mb-6"
                        >
                            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="field-crop">
                                Neighbor phone
                            </label>
                            <div class="relative">
                                <input
                                    v-model="neighbourPhone"
                                    :class="{'border-red-500': errorMessages.mobile}"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 pr-10 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    id="phone"
                                    type="tel"
                                    placeholder="Enter phone number e.g. +123456789"
                                >
                            </div>
                            <p v-if="errorMessages.mobile" class="mt-2 text-red-500 text-xs italic">Please enter phone number!</p>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                        @click="submitForm()"
                    >
                        Send Invite
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'MapInviteModal',

    data: () => ({
        neighbourEmail: '',
        neighbourPhone: '',
        errorMessages: {
            email: false,
            mobile: false,
        },
        triedToSubmit: false,
        tabs: [
            {
                name: 'Email',
            },
            {
                name: 'Text',
            },
        ],
        activeTab: 'Email'
    }),

    computed: {
        ...mapGetters('user', ['getActiveFarmName']),
    },

    watch: {
        neighbourEmail(newValue) {
            if (!this.triedToSubmit) return;
            this.errorMessages.email = !!newValue;
        },
        neighbourPhone(newValue) {
            if (!this.triedToSubmit) return;
            this.errorMessages.mobile = !!newValue;
        },
    },

    methods: {
        submitForm() {
            this.triedToSubmit = true;

            if (this.activeTab === 'Email' && !this.neighbourEmail) {
                this.errorMessages.email = true;
                return;
            }

            if (this.activeTab === 'Text' && !this.neighbourPhone) {
                this.errorMessages.mobile = true;
                return;
            }

            const emitData = this.activeTab === 'Email'
                ? {
                    email: this.neighbourEmail,
                    'farm_name': this.getActiveFarmName,
                }
                : {
                    mobile: this.neighbourPhone,
                    'farm_name': this.getActiveFarmName,
                }

            this.$emit('submit', emitData);
        },

        changeTab(tabName) {
            this.activeTab = tabName;
            this.errorMessages.mobile = false;
            this.errorMessages.email = false;
        }
    }
}
</script>